import 'velocity-animate';

var
    moduleName = 'smart-form',

    classes = {
        form:   'js-' + moduleName,
        active: 'is-active'
    },

    selectors = {
        form:     '.' + classes.form,
        item:     '.' + classes.form +'-item',
        followup: '.' + classes.form +'-followup'
    },

    $elements = {
        body:     $('body'),
        form:     $(selectors.form),
        followup: $(selectors.followup)
    },

    events = {
        change: 'change.' + moduleName
    },

    attributes = {
        followup: 'followup'
    },

    duration = 200;

/**
 * Check if the selected value of the control contains a follow up
 * @param  {jQuery} $control jQuery wrapped form element
 */
function checkFollowUp($control) {
    var val = $control.val();
    var $el = $elements.form.find('[value="' + val + '"]');
    var followup = $el.data('followup');

    if (followup) {
        if (followup.url) {
            window.location = followup.url;
        } else if (followup.html) {
            $elements.followup.html(followup.html);
        }
    }
}

/**
 * Change handler callback
 * @param  {Event} e  The change event
 */
function changeHandler(e) {
    var $control = $(this),
        questionId = $control.attr('name'),
        answerId = $control.val();

    if($(e.target).parent().is('label')) {
        var $item = $(e.target).closest(selectors.item);
        $item.siblings().removeClass(classes.active);
        $item.toggleClass(classes.active);
    }

    $('[data-question-id="' + questionId + '"]').hide();
    $('[data-question-id="' + questionId + '"][data-answer-id="' + answerId + '"]').show();

    if(answerId){
      checkFollowUp($control);
    }
}

/**
 * Initialize this module
 */
function init() {
    $elements.body.on(events.change, ':input', changeHandler);
}

// if any smart form elements present, init this module
if($elements.form.length) {
    init();
}
